import { connect } from 'react-redux';
import ResetPasswordComponent from '../views/forget_password/resetPasswordComponent';
import { incrementCount } from '../../redux/actions/authentication';

const mapStateToProps = (state) => ({
    count : state.authentication.count
});

const mapDispatchToProps = (dispatch) => ({
    incrementCount : () => dispatch(incrementCount())
});

const ResetPassword = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordComponent);

export default ResetPassword;
